import {h, render} from 'vue'

export function useCreateComponent({component, props, el}) {
    const expose = h(component, props)
    expose.appContext = useNuxtApp().vueApp._context
    render(expose, el)
    return expose.component.exposed
}
